import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function contactUsReducer(state = initialState, action) {
    
    const {type, payload} = action;
    switch (type) {
        case t.POST_CONTACT_US_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.POST_CONTACT_US_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.POST_CONTACT_US_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}